<template>
  <div class="category-breadcrumbs-container">
    <span>
      <span class="category-breadcrumb">
        <router-link to="/" class="category-breadcrumb-link">
          Home
        </router-link>
      </span>
      |
    </span>
    <span v-for="(path, index) in categoryPath" :key="path.identifier">
      <span class="category-breadcrumb">
        <router-link
          class="category-breadcrumb-link"
          :to="`${path.link}?lang=${language}`"
        >
          {{ path.name }}
        </router-link>
      </span>
      <span v-if="index < categoryPath.length - 1"> | </span>
    </span>
  </div>
</template>

<script>
import { getCategoryPath } from "@/helpers/categories";

export default {
  name: "CategoryBreadcrumb",
  props: {
    language: {
      type: String,
      default: "en",
    },
    productPath: {
      type: Object,
      default: null,
    },
  },
  computed: {
    categoryPath() {
      let identifier;
      if (!this.productPath) {
        identifier = this.$route.params.categoryIdentifier;
      } else {
        identifier =
          this.productPath.leaves[this.productPath.leaves.length - 1];
      }

      if (!this.$store.getters.categoryTree.length) {
        this.$store.dispatch("fetchCategories");
      }

      const path = getCategoryPath(
        identifier,
        this.language,
        this.$store.getters.categoryTree
      );

      if (this.productPath) {
        path?.push({
          identifier: this.productPath.productId,
          link: this.productPath.productId,
          name: this.productPath.name[this.language],
        });
      }

      return path;
    },
  },
};
</script>

<style>
.category-breadcrumbs-container span,
.category-breadcrumb-link {
  font-size: var(--smaller-text);
  color: var(--rofix-gray);
}

.category-breadcrumb-pointer {
  height: auto;
  width: auto;
}

.category-breadcrumb {
  margin: 0 0.2rem;
}

.category-breadcrumb-link {
  text-decoration: none;
}

.category-breadcrumb-link:hover {
  text-decoration: underline;
}
</style>
